<div class="content-layout left-sidebar-fullheight-basic-inner-scroll">
  <mat-drawer-container>
    <mat-drawer-content>
      <!-- Main -->
      <div class="main">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
